import { isSafari } from "../common";
const SHADOW_DPI = 0.0071;
export function updateCanvasShadows(canvas, canvasShadows, camera) {
  var _a, _b, _c, _d, _e, _f;
  let styleFilter = "";
  const softSpread = (_a = canvasShadows.softSpread) !== null && _a !== void 0 ? _a : 2.5;
  const hardSpread = (_b = canvasShadows.hardSpread) !== null && _b !== void 0 ? _b : 0.5;
  const hardOffset = (_c = canvasShadows.hardOffset) !== null && _c !== void 0 ? _c : {
    x: 0,
    y: 0.5
  };
  // Add soft spread shadows
  if (softSpread > 0) {
    const spreadAmount = canvas.offsetWidth * SHADOW_DPI * softSpread * camera.zoomFactor;
    // Intensify and shrink the single default drop shadow for safari since it can only render one
    if (isSafari) {
      styleFilter += " drop-shadow(0px 0px ".concat((spreadAmount * 0.5).toFixed(2), "px ").concat((_d = canvasShadows.softColor) !== null && _d !== void 0 ? _d : "rgba(0,0,0,0.08)", ")");
    } else {
      styleFilter += " drop-shadow(0px 0px ".concat(spreadAmount.toFixed(2), "px ").concat((_e = canvasShadows.softColor) !== null && _e !== void 0 ? _e : "rgba(0,0,0,0.05)", ")");
    }
  }
  // Add hard spread shadows when browser support is available
  if (hardSpread > 0 && !isSafari) {
    const spreadAmount = (canvas.offsetWidth * SHADOW_DPI * hardSpread * camera.zoomFactor).toFixed(2);
    const offsetX = (canvas.offsetWidth * SHADOW_DPI * hardOffset.x * camera.zoomFactor).toFixed(2);
    const offsetY = (canvas.offsetWidth * SHADOW_DPI * hardOffset.y * camera.zoomFactor).toFixed(2);
    styleFilter += " drop-shadow(".concat(offsetX, "px ").concat(offsetY, "px ").concat(spreadAmount, "px ").concat((_f = canvasShadows.hardColor) !== null && _f !== void 0 ? _f : "rgba(0,0,0,0.04)", ")");
  }
  // eslint-disable-next-line no-param-reassign
  canvas.style.filter = styleFilter;
}